if (!customElements.get('card-add-button')) {
  customElements.define(
    'card-add-button',
    class CardAddButton extends HTMLElement {
      constructor() {
        super();
        this.cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.addEventListener('click', this.onClickHandler.bind(this));
      }

      get variantId() {
        return this.dataset.variantId;
      }

      get hasVariants() {
        return this.dataset.hasVariants === 'true';
      }

      get productId() {
        return this.dataset.productId;
      }

      get iconEl() {
        return this.querySelector('.card-product__add-btn-icon');
      }

      get spinnerEl() {
        return this.querySelector('.loading__spinner');
      }

      onClickHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        if (this.classList.contains('loading') || this.classList.contains('added')) return;

        if (this.hasVariants) {
          this.openQuickAdd();
          return;
        }

        this.addToCart();
      }

      openQuickAdd() {
        const modal = document.querySelector(`#QuickAdd-${this.productId}`);
        if (modal) {
          modal.show(this);
        }
      }

      addToCart() {
        this.classList.add('loading');
        if (this.spinnerEl) this.spinnerEl.classList.remove('hidden');
        if (this.iconEl) this.iconEl.style.display = 'none';

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', 1);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Error
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'card-add-button',
                productVariantId: this.variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.showError();
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'card-add-button',
              productVariantId: this.variantId,
              cartData: response,
            });

            if (this.cart) {
              this.cart.renderContents(response);
            }

            this.showSuccess();
          })
          .catch((e) => {
            console.error(e);
            this.showError();
          })
          .finally(() => {
            this.classList.remove('loading');
            if (this.spinnerEl) this.spinnerEl.classList.add('hidden');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
          });
      }

      showSuccess() {
        this.classList.add('added');
        if (this.iconEl) {
          this.iconEl.style.display = '';
          this.iconEl.textContent = '\u2713';
        }

        setTimeout(() => {
          this.classList.remove('added');
          if (this.iconEl) {
            this.iconEl.textContent = '+';
          }
        }, 1200);
      }

      showError() {
        if (this.iconEl) {
          this.iconEl.style.display = '';
          this.iconEl.textContent = '!';
        }

        setTimeout(() => {
          if (this.iconEl) {
            this.iconEl.textContent = '+';
          }
        }, 1500);
      }
    }
  );
}
